/*
  NOTE: IF CHANGING ANY STANDARD COLOR, PLEASE UPDATE THE VALUES ON utils/getPalleteColor
*/
/*
 NOTE: This theme is specific to the CZ and TR market.
*/

const spacing = (size: number) => `${size * 10}px`;

export default spacing;
